import * as cssVariable from 'cssVariables';
import { breakpoints, mediaQuery } from 'components/theme/breakpoints';

export default {
  profileThumb: {
    display: 'inline-block',
    width: 28,
    height: 28,
    margin: '0 10px',
    backgroundSize: 'cover',
    borderRadius: '50%',
    [mediaQuery.maxWidth(breakpoints.md)]: {
      margin: 0,
    },
  },
  dropdownBtn: {
    height: 30,
    background: cssVariable.white,
    border: 0,
    color: '#0091FF',
    fontWeight: 'bold',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: 10,
    padding: 10,
    '& span': {
      maxWidth: 85,
    },
  },

  chevron: {
    transform: 'rotate(90deg)',
    color: cssVariable.blue500,
    width: '2.4em',
    height: '2.4em',
    position: 'relative',
    left: -5,
  },

  turnChevron: {
    transform: 'rotate(270deg)',
  },

  dropdownHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 150,
    height: '100%',
  },

  dropdownHeaderOpen: {
    boxShadow: '2px 8px 17px 0 rgba(116,116,116,0.5)',
    borderRadius: [3, 3, 0, 0],
  },

  dropdown: {
    cursor: 'pointer',
    height: 70,
    marginLeft: 5,
  },

  dropdownContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    background: cssVariable.white,
    width: 150,
    color: cssVariable.grey500,
    borderRadius: [0, 0, 3, 3],
    boxShadow: '2px 8px 17px 0 rgba(116,116,116,0.5)',
    clipPath: 'inset(0px -20px -20px -20px)',
  },

  dropdownContentHide: {
    display: 'none',
  },

  link: {
    fontWeight: 'bold',
    color: cssVariable.grey500,
    '&:hover': {
      color: cssVariable.blue500,
    },
    backgroundColor: cssVariable.white,
  },

  favouriteIcon: {
    padding: 8,
    '& svg': {
      height: 18,
    },
  },

  editProfileIcon: {
    padding: 8,
    marginLeft: 23,
    '& svg': {
      height: 27,
      width: 27,
    },
  },

  logoutIcon: {
    padding: [8, 8, 8, 0],
    '& svg': {
      height: 27,
      width: 27,
    },
  },

  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    '&:hover, &:hover a': {
      color: cssVariable.blue500,
    },
    padding: 3,
    height: 40,
  },

  profileIcon: {
    marginLeft: 5,
  },

  dropdownButtons: {
    background: cssVariable.white,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },

  navLink: {
    textDecoration: 'none',
  },
};
